<template>
  <div class="order-wrapper">
    <div class="order-wrapper-title">{{$t('design.order.orderTitle') || "设计订单"}}</div>
    <div class="table-box">
		<orderTableIndex></orderTableIndex>
    </div>
	<afterSalesDialog></afterSalesDialog>
  </div>
</template>

<script setup>
import { XlTabs, XlScrollbar } from "@shining3d/ui-components";
import { ref } from "vue";
import orderTableIndex from './orderTableIndex.vue'
import afterSalesDialog from './components/afterSalesDialog.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");
</script>

<script>
export default {
	name: 'designOrder'
}
</script>

<style lang="scss" scoped>
.order-wrapper {
  height: 100%;
  padding: 16px 16px 0 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #ffffff;
  overflow: hidden;
  .order-wrapper-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 25.2px;
    margin-bottom: 8px;
    color: #2c364e;
  }
//   :deep(.xl-tabs .el-tabs__nav-wrap) {
//     padding-left: 0 !important;
//   }
//   :deep(.el-tabs__content){
// 		padding: 0 !important;
// 		flex: 1;
//     	overflow: auto;
// 	}
	.table-box{
		width: 100%;
		// height: calc(100% - 18px);
		display: flex;
		flex-flow: column nowrap;
		flex: 1;
		overflow: hidden;
	}
	// :deep(.el-tabs){
	// 	width: 100%;
	// 	height: 100%;
	// 	display: flex;
	// 	flex-flow: column nowrap;
	// 	flex-grow: 1;
	// }
	// :deep(.el-tab-pane){
	// 	height: 100%;
	// 	display: flex;
	// 	flex-flow: column nowrap;
	// 	flex-grow: 1;
	// }
}
</style>
